// extracted by mini-css-extract-plugin
export default {"container__verprodutos":"VerProdutos_container__verprodutos__rQrOG","back__btn":"VerProdutos_back__btn__9d8s+"};